import './survey-first-answer';

const buttonLink = document.getElementById('link-laguna-propriedades');
const buttonCard = document.getElementById('card-laguna-propriedades');


if (buttonLink && buttonCard) {
  buttonLink.addEventListener('click', function () {
    setTimeout(() => {
      buttonCard.classList.add('isActive');
    }, 1000)

    setTimeout(() => {
      buttonCard.classList.remove('isActive');
    }, 5000)
  })
}
